<template>
  <div class="box4">
    <pageTitle
      title="AI风口已来<br/>这四类人最该抢占AI红利"
      text="告别职业瓶颈，解锁高薪未来，AI赛道就是你的最优解"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="card-list">
      <div
        class="card"
        v-for="(item, index) in cardList"
        :key="index"
        :style="{ backgroundImage: `url(${item.avatar})` }"
      >
        <div class="card__content">
          <h3 class="card__title">{{ item.title }}</h3>
          <p class="card__problem">{{ item.problem }}</p>
          <p class="card__solution" v-html=" item.solution"></p>
        </div>
      </div>
    </div>

    <ConsultBtn text="解锁AI入行路径" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      cardList: [
        {
          title: "职场转行",
          problem: "行业内卷、薪资难涨，担心被AI替代？",
          solution: "告别职业瓶颈，抓住AI风口重启人生，<br/>实现高薪转行",
          avatar: require("../../../assets/coursePage/llm/box4/1-bg.png"),
        },
        {
          title: "高学历低收入",
          problem: "专业错位、薪资普通、转型无路径？",
          solution:
            "告别收入憋屈，成为企业争抢的AI人才，<br/>让高学历匹配高薪资",
          avatar: require("../../../assets/coursePage/llm/box4/2-bg.png"),
        },
        {
          title: "大学生",
          problem: "学用脱节，缺核心竞争力、求职难？",
          solution: "提前布局AI新兴赛道，打造核心竞争力，<br/>实现高起点就业",
          avatar: require("../../../assets/coursePage/llm/box4/3-bg.png"),
        },
        {
          title: "传统程序员",
          problem: "技术单一、薪资停滞、面临行业淘汰？",
          solution: "完成技术迭代升级，打破职业发展瓶颈，<br/>实现薪资翻倍",
          avatar: require("../../../assets/coursePage/llm/box4/4-bg.png"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box4 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box4/bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  background-color: #f3f6ff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
  }

  .card-list {
    position: relative;
    z-index: 1;
    margin-top: 48px;
  }

  .card {
    position: relative;
    min-height: 256px;
    margin-bottom: 24px;
    padding: 32px 120px 32px 40px;
    box-sizing: border-box;
    border-radius: 28px;
   
    box-shadow: 0 4px 30px rgba(204, 211, 232, 0.44);
   
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;

    &:last-child {
      margin-bottom: 0;
    }

    &__title {
      font-family: PingFangSC, PingFang SC;
      font-size: 34px;
      font-weight: 600;
      color: #072557;
      line-height: 48px;
    }

    &__problem {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #667691;
      line-height: 40px;
    }

    &__solution {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      line-height: 44px;
      .llm-text-gradient();
    }

  }

}
</style>
